import type {ProductProps} from '@/molecules/Cards/Product/typings';
import type {SuccessApiResponseBody} from '@/redux/actions/featuredArtActions';
import type {RootState} from '@/redux/store';
import type {StatusType, ReduxAction} from './typings';

import {
  STATUS_IDLE,
  STATUS_LOADING,
  STATUS_SUCCEEDED,
  STATUS_FAILED,
  LOAD_FEATURED_ART_REQUEST,
  LOAD_FEATURED_ART_SUCCESS,
  LOAD_FEATURED_ART_FAILURE,
  SEED_FEATURED_ART_SUCCESS,
  SEED_FEATURED_ART_FAILURE,
} from '../actionTypes';

type FeaturedArtActionTypes =
  | typeof LOAD_FEATURED_ART_REQUEST
  | typeof LOAD_FEATURED_ART_SUCCESS
  | typeof LOAD_FEATURED_ART_FAILURE
  | typeof SEED_FEATURED_ART_SUCCESS
  | typeof SEED_FEATURED_ART_FAILURE;

export interface FeaturedArtState {
  status: {
    ssr: StatusType;
    client: StatusType;
  };
  data: ProductProps[];
  error: null | string;
}

export const initialState: FeaturedArtState = {
  status: {
    ssr: STATUS_IDLE,
    client: STATUS_IDLE,
  },
  data: [],
  error: null,
};

const featuredArtReducer = (
  state = initialState,
  action: ReduxAction<SuccessApiResponseBody, FeaturedArtActionTypes>,
) => {
  switch (action.type) {
    case LOAD_FEATURED_ART_REQUEST:
      return {
        ...state,
        status: {...state.status, client: STATUS_LOADING},
        error: null,
      };

    case LOAD_FEATURED_ART_SUCCESS:
      return {
        ...state,
        status: {...state.status, client: STATUS_SUCCEEDED},
        data: action.response?.data.results as ProductProps[],
      };

    case LOAD_FEATURED_ART_FAILURE:
      return {
        ...state,
        status: {...state.status, client: STATUS_FAILED},
        error: action.error?.message as string,
      };

    case SEED_FEATURED_ART_SUCCESS:
      return {
        ...state,
        status: {...state.status, ssr: STATUS_SUCCEEDED},
        data: action.response?.data.results as ProductProps[],
      };

    case SEED_FEATURED_ART_FAILURE:
      return {
        ...state,
        status: {...state.status, ssr: STATUS_FAILED},
        error: 'Failed to load from SSR',
      };

    default:
      return state;
  }
};

export const selectFeaturedArt = (state: RootState) => state.featuredArt;

export default featuredArtReducer;
